import { CreateReviewsContext } from "contexts/MightyTool";
import { useContext } from "react";
const useCreateReviews = () => useContext(CreateReviewsContext);
export default useCreateReviews;
